module.exports = __webpack_public_path__ + "media/images/camera_pause-573efd98562bb6fe41e8f238e6ceeea8.svg";